import React from 'react';

import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { Button, SimpleText } from 'platform-components';

import { ASSIGNMENT_STATES } from 'common.components/lesson-view.assignment/typings';

import { ACTION_BUTTON_MODE } from '../action-button-mode';
import { mixinAssignLessonButtonMembers, AssignLessonButtonWrapper, type Props } from './members';

/** Кнопка выдачи урока */
class AssignLessonButton extends mixinAssignLessonButtonMembers(React.Component<Props>) {
    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { assignmentState, setExpanded } = this.props;

        if (
            assignmentState === ASSIGNMENT_STATES.SUBMITTING &&
            prevProps.assignmentState === ASSIGNMENT_STATES.VALIDATING
        ) {
            this.assignLesson();
        }

        if (assignmentState === ASSIGNMENT_STATES.ERROR && prevProps.assignmentState === ASSIGNMENT_STATES.VALIDATING) {
            // при ошибке надо развернуть блок выдачи (переключатель на мобилках, на десктопах всегда развернут)
            setExpanded(true);
        }
    }

    handleClickButton = async () => {
        const { setAssignmentState } = this.props;

        setAssignmentState(ASSIGNMENT_STATES.VALIDATING);
    };

    render() {
        const { assignmentState, buttonMode, loadingStatus, canAssignLesson, isLoadingLessonViewData } = this.props;
        const shouldShowLoader =
            loadingStatus === LOADING_STATUSES.LOADING ||
            isLoadingLessonViewData ||
            assignmentState === ASSIGNMENT_STATES.SUBMITTING ||
            assignmentState === ASSIGNMENT_STATES.VALIDATING;

        return (
            <Button
                className="side-panel__action-button"
                disabled={!canAssignLesson}
                onClick={shouldShowLoader ? undefined : this.handleClickButton}
                progress={shouldShowLoader}
            >
                <SimpleText
                    id={
                        buttonMode === ACTION_BUTTON_MODE.REASSIGN_LESSON
                            ? 'lessonView.sidePanel.reassignment.button'
                            : 'lessonModal.header.assignment'
                    }
                />
            </Button>
        );
    }
}

const container = AssignLessonButtonWrapper(AssignLessonButton);

container.displayName = 'AssignLessonButton';

export default container;
